var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_6734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.64 2.95585C14.5867 2.88355 14.5138 2.82802 14.43 2.79585L8.43 0.525849C8.37323 0.501071 8.31195 0.488281 8.25 0.488281C8.18805 0.488281 8.12677 0.501071 8.07 0.525849L2.07 2.83585C1.99073 2.85684 1.91833 2.89821 1.86 2.95585C1.79015 3.04035 1.75133 3.14622 1.75 3.25585V10.5758C1.7513 10.6757 1.78247 10.7729 1.83951 10.8549C1.89654 10.9369 1.97682 10.9999 2.07 11.0358L8.07 13.3458H8.25H8.43L14.43 11.0358C14.5232 10.9999 14.6035 10.9369 14.6605 10.8549C14.7175 10.7729 14.7487 10.6757 14.75 10.5758V3.29585C14.7585 3.17258 14.7191 3.0508 14.64 2.95585V2.95585Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.4161V5.45605",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.45605V13.4161",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85999 2.99609L8.24999 5.45609L14.64 2.99609",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_6734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.e9f2ec7d26ec975732d6f058417059eb.svg";
export { ForwardRef as ReactComponent };